import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { featureGuard } from './core/guards/feature.guard';
import { permissionGuard } from './core/guards/permission.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadComponent: () => import('./layouts/auth-layout/auth-layout').then((m) => m.AuthLayout),
    children: [
      {
        path: 'login',
        loadComponent: () => import('./pages/login/login').then((m) => m.Login),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('./pages/forgot-password/forgot-password').then((m) => m.ForgotPassword),
      },
      {
        // Opened from the forgot-password email: /auth/reset-password?token=…
        path: 'reset-password',
        loadComponent: () =>
          import('./pages/reset-password/reset-password').then((m) => m.ResetPassword),
      },
    ],
  },
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layouts/app-layout/app-layout').then((m) => m.AppLayout),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard').then((m) => m.Dashboard),
      },
      {
        path: 'positions',
        canActivate: [featureGuard('positionHistory')],
        loadComponent: () => import('./pages/positions/positions').then((m) => m.Positions),
      },
      {
        path: 'bulk-theft',
        canActivate: [featureGuard('nwnfBatchCreation'), permissionGuard('create-manual-vehicle')],
        loadComponent: () => import('./pages/bulk-theft/bulk-theft').then((m) => m.BulkTheft),
      },
      {
        // ROL-01: user create/modify/disable — Administrator-only (server re-checks manage-users).
        path: 'admin/users',
        canActivate: [
          featureGuard('userAdministration'),
          permissionGuard('manage-users', 'manage-soc-agents'),
        ],
        loadComponent: () => import('./pages/admin/users/users').then((m) => m.Users),
      },
      {
        // THEFT-17: constabulary/insurer/extra-found-criteria managed picklists.
        path: 'admin/picklists',
        canActivate: [featureGuard('managedPicklists'), permissionGuard('manage-picklists')],
        loadComponent: () => import('./pages/admin/picklists/picklists').then((m) => m.Picklists),
      },
    ],
  },
  {
    // SHR-01: intentionally NOT behind authGuard — this is the non-authenticated shareable link.
    path: 'track/:token',
    loadComponent: () => import('./pages/track/track').then((m) => m.Track),
  },
  { path: '**', redirectTo: 'dashboard' },
];
